<template>
    <!-- <div id="sidebar" class="scrollbar" :class="(collapseVar == true)? 'active' : ''"> -->
    <div id="sidebar"  class="iconMobileLeftbar" :class="(classMobileResponsive)?'active' : 'inactive'">
        <div class="cap_logo"> 
            <router-link :to="'/dashboard'" class="green">
                <img src="../../../../static/fxView/images/fxview_logo_white.svg" alt="fxView">
            </router-link>
        </div>
        <div class="cap_leftbar p_right"> 
            <div class="left_scrollbar"> 
                <!---------------left nav---------------->
                <nav class="side-navbar main-menu scrollbar">
                    <div class="closeSideBar d-xl-none">
                        <a href="#" class="closeIT" @click.prevent="$parent.mobmenu = !$parent.mobmenu"><feather type="x"></feather></a>
                    </div>
                    <ul id="side-main-menu" class="side-menu list-unstyled">
						<!--:class="(activeLi == 'dashboard')? 'active' : ''" @click.prevent="chnageLeft('dashboard')"-->
                         <li>
                            <router-link to="/dashboard" @click.native="handleEventTracking('dashboard')"> 
                                <i class="leftIco">
                                    <feather size="17px" type="home"></feather>
                                    <!-- <img src="../../../../static/fxView/images/dashboard.svg" alt="Add Deposit"> -->
                                </i>
                                <span class="menutxt">{{$t('leftnav_dashboard')}}</span>                                 
                            </router-link>  
                        </li>
                        <!-- <li>
                            <a href="#"> 
                                <i class="leftIco">
                                   <feather size="17px" type="bar-chart"></feather>
                                </i>
                                <span class="menutxt">Web Trader</span>                                 
                            </a>  
                        </li>
                        -->
                        <li>
                            <router-link to="/wallet" @click.native="handleEventTracking('wallet')">  
                                <i class="leftIco">
                                    <feather size="17px" type="folder"></feather>
                                </i>
                                <span class="menutxt">{{$t('leftnav_wallet')}}</span>                                 
                            </router-link>  
                        </li>
                        <li v-if="checkROll('deposits') || checkROll('withdrawals')">
                            <router-link to="/account-funding" @click.native="handleEventTracking('account-funding')"> 
                                <i class="leftIco">
                                     <feather size="17px" type="credit-card"></feather>
                                </i>
                                <span class="menutxt">{{$t('leftnav_accfunding')}}</span>                                 
                            </router-link>  
                        </li>
                        <li>
                            <router-link to="/account" @click.native="handleEventTracking('account')"> 
                                <i class="leftIco">
                                     <feather size="17px" type="user"></feather>
                                </i>
                                <span class="menutxt">{{$t('leftnav_manageAcc')}}</span>                                 
                            </router-link>  
                        </li>
                        <li>
                            <router-link to="/deposit-bonus" @click.native="handleEventTracking('deposit-bonus')"> 
                                <i class="leftIco">
                                     <feather size="17px" type="gift"></feather>
                                </i>
                                <span class="menutxt">{{$t('leftnav_Depositbonus')}}</span>                                 
                            </router-link>  
                        </li>
                        <li>
                            <router-link to="/social-trade" @click.native="handleEventTracking('social-trade')"> 
                                <i class="leftIco">
                                     <feather size="17px" type="user-plus"></feather>
                                </i>
                                <span class="menutxt">{{$t('leftnav_socialTrade')}}</span>                                 
                            </router-link>  
                        </li>
                        <li>
                            <router-link to="/tools/Overview" :class="[{'router-link-exact-active router-link-active':$route.name == 'tools'}]" @click.native="handleEventTracking('tools')"> 
                                <i class="leftIco">
                                     <feather size="17px" type="settings"></feather>
                                </i>
                                <span class="menutxt">{{$t('leftnav_tools')}}</span>                                 
                            </router-link>  
                        </li>
                        <li>
                            <router-link to="/research-and-education/Market-Insights"  @click.native="handleEventTracking('research-and-education')" :class="[{'router-link-exact-active router-link-active':$route.name == 'research_and_education'}]"> 
                                <i class="leftIco">
                                     <feather size="17px" type="book-open"></feather>
                                </i>
                                <span class="menutxt">{{$t('leftnav_education')}}<br> {{$t('leftnav_resources')}}</span>                                 
                            </router-link>  
                        </li>
                        <li>
                            <router-link to="/download-platform" @click.native="handleEventTracking('download-platform')"> 
                                <i class="leftIco">
                                     <feather size="17px" type="download"></feather>
                                </i>
                                <span class="menutxt">{{$t('leftnav_downloadplatform')}}</span>                                 
                            </router-link>  
                        </li> 
                        <li :class="(activeLi == 'support')? 'active' : ''" @click.prevent="chnageLeft('support')">
                            <router-link  :to="{name: 'fxView.support' , params: { 'tabName':'requestServiceElement'}}" @click.native="handleEventTracking('support')">    
                                <i class="leftIco">
                                    <!-- <img src="../../../../static/fxView/images/support.svg" alt="Support"> -->
                                    <feather size="17px" type="headphones"></feather>
                                </i>
                                <span class="menutxt">{{$t('leftnav_support')}}</span>  
                            </router-link> 
                        </li> 
                        <!-- <li  :class="(activeLi == 'mnge')? 'active' : ''" @click.prevent="chnageLeft('mnge')">
                            <router-link to="#" class="subMenuClass">
                                 
                                <i class="leftIco">
                                    <img src="../../../../static/fxView/images/manageaccount.svg" alt="Add Deposit">
                                </i>
                                <span class="menutxt">{{$t('manageAccount')}}</span>
                                <feather type="chevron-down" class="down_arrow"></feather>
                            </router-link> 
                            <ul class="sub_menu">
                                <li>
                                    <router-link :to="'/account-list'">
                                        <i class="leftIco">
                                            <img src="../../../../static/fxView/images/list.svg" alt="Account List">
                                        </i>
                                        <span class="menutxt">{{$t('accountList')}}</span> 
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="'/change-leverage'">
                                        <i class="leftIco">
                                            <img src="../../../../static/fxView/images/leverageico.svg" alt="Change Leverage">
                                        </i>
                                        <span class="menutxt">{{$t('changeLeverage')}}</span> 
                                    </router-link> 
                                </li>
                                <li>
                                    <router-link :to="'/account/change/password'">
                                        <i class="leftIco">
                                            <img src="../../../../static/fxView/images/password.svg" alt="Change Password">
                                        </i>
                                        <span class="menutxt">{{$t('changePassword')}}</span> 
                                    </router-link> 
                                </li>
                                <li>
                                    <router-link :to="'/internal-transfer'">
                                        <i class="leftIco">
                                            <img src="../../../../static/fxView/images/internal_transfer.svg" alt="Internal Transfer">
                                        </i>
                                        <span class="menutxt">{{$t('internalTransfer')}}</span> 
                                    </router-link> 
                                </li>
                            </ul>
                        </li>
                        <li  :class="(activeLi == 'deposit')? 'active' : ''" @click.prevent="chnageLeft('deposit')">
                            <router-link to="#" class="subMenuClass"> 
                                <i class="leftIco">
                                    <img src="../../../../static/fxView/images/deposit.svg" alt="Add Deposit">
                                </i>
                                <span class="menutxt">{{$t('deposit')}}</span> 
                                <feather type="chevron-down" class="down_arrow"></feather>
                            </router-link> 
                            <ul class="sub_menu">
                                <li>
                                    <router-link :to="'/deposit'">
                                        <i class="leftIco">
                                            <img src="../../../../static/fxView/images/adddeposit.svg" alt="Add Deposit">
                                        </i>
                                        <span class="menutxt">{{$t('addDeposit')}}</span>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link :to="'/deposit-list'"> 
                                        <i class="leftIco">
                                            <img src="../../../../static/fxView/images/list.svg" alt="Account List">
                                        </i>       
                                        <span class="menutxt">{{$t('depositList')}}</span>
                                    </router-link> 
                                </li>
                            </ul>  
                        </li>
                        <li  :class="(activeLi == 'withdrawal')? 'active' : ''" @click.prevent="chnageLeft('withdrawal')">
                            <router-link to="#" class="subMenuClass">
                               
                                <i class="leftIco">
                                    <img src="../../../../static/fxView/images/withdrawal.svg" alt="Add Deposit">
                                </i>
                                <span class="menutxt">{{$t('withdrawal')}}</span> 
                                <feather type="chevron-down" class="down_arrow"></feather>
                            </router-link>
                            <ul class="sub_menu">
                                 <li>
                                    <router-link :to="'/withdrawal'">
                                        <i class="leftIco">
                                            <img src="../../../../static/fxView/images/list.svg" alt="Account List">
                                        </i>
                                        <span class="menutxt">{{$t('makewithdrawal')}}</span>
                                    </router-link>
                                 </li> 
                                 <li>
                                    <router-link :to="'/withdrawal-list'">
                                        <i class="leftIco">
                                            <img src="../../../../static/fxView/images/list.svg" alt="Account List">
                                        </i>
                                        <span class="menutxt">{{$t('withdrawalList')}}</span>
                                    </router-link>
                                </li> 
                            </ul>
                        </li>                        
                        
                        
                        <li  :class="(activeLi == 'tools')? 'active' : ''" @click.prevent="chnageLeft('tools')">
                            <router-link to="#" class="subMenuClass">                                
                                <i class="leftIco">
                                    <img src="../../../../static/fxView/images/tools.svg" alt="tools">
                                </i>
                                <span class="menutxt">{{$t('tools')}}</span> 
                                <feather type="chevron-down" class="down_arrow"></feather>
                            </router-link>
                            <ul class="sub_menu">
                                <li>
                                    <router-link :to="'/auto-chartist'">
                                        <i class="leftIco">
                                            <img src="../../../../static/fxView/images/list.svg" alt="Auto Chartist">
                                        </i>
                                        <span class="menutxt">{{$t('AutoChartist')}}</span> 
                                    </router-link> 
                                </li>
                                <li>
                                    <router-link :to="'/signal-centre'">
                                        <i class="leftIco">
                                            <img src="../../../../static/fxView/images/list.svg" alt="Signal Center">
                                        </i>
                                        <span class="menutxt">{{$t('SignalCenter')}}</span> 
                                    </router-link> 
                                </li> 
								<li>
                                    <router-link :to="'/vps-list'">
                                        <i class="leftIco">
                                            <img src="../../../../static/fxView/images/list.svg" alt="Signal Center">
                                        </i>
                                        <span class="menutxt">{{$t('VPS')}}</span> 
                                    </router-link> 
                                </li>
								<li>
                                    <router-link :to="'/economic-calendar'">
                                        <i class="leftIco">
                                            <img src="../../../../static/fxView/images/list.svg" alt="Signal Center">
                                        </i>
                                        <span class="menutxt">{{$t('EconomicCalender')}}</span> 
                                    </router-link> 
                                </li>
								<li>
                                    <router-link :to="'/trade-news'">
                                        <i class="leftIco">
                                            <img src="../../../../static/fxView/images/list.svg" alt="Signal Center">
                                        </i>
                                        <span class="menutxt">{{$t('TradeNews')}}</span> 
                                    </router-link> 
                                </li>
								<li>
                                    <router-link :to="'/tradertool-box'">
                                        <i class="leftIco">
                                            <img src="../../../../static/fxView/images/list.svg" alt="Signal Center">
                                        </i>
                                        <span class="menutxt">Trader’s Tool Box</span> 
                                    </router-link> 
                                </li>
                            </ul> 
                        </li> 

                        -->

                        
                    </ul>
                </nav> 
                  <!-- <div class="getStartButton text-center"> 
                   <img src="../../../../static/fxView/images/referFriend.svg" alt="Icon">
                    <router-link to="/refer-a-friend" class="btn_xs grd_btn mr-md-2 newtrading">Refer a friend</router-link>
                </div> -->
               
            <!------------------------------------->
            </div>
        </div>
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
 
    
    export default {
        name: 'Dashboard',
        mixins: [fxViewMixins],
        data() {
            return {
                showStepComponent: false,
                activeLi: "",
                
            }
        },
		props:['classMobileResponsive'],
       
        methods:{
            chnageLeft(left){
                if(this.activeLi == left){
                    this.activeLi = '' 
                }else{
                    this.activeLi = left   
                } 
            },
            handleEventTracking(route){
                switch (route){
                    case 'dashboard':
                        this.$trackEvent('CP+Menu+Dashboard');
                    break;
                    case 'wallet':
                        this.$trackEvent('CP+Menu+Wallet');
                    break;
                    case 'account-funding':
                        this.$trackEvent('CP+Menu+Account+Funding');
                    break;
                    case 'account':
                        this.$trackEvent('CP+Menu+Manage+Accounts');
                    break;
                    case 'deposit-bonus':
                        this.$trackEvent('CP+Menu+Deposit+Bonus');
                    break;
                    case 'social-trade':
                        this.$trackEvent('CP+Menu+Social+Trading');
                    break;
                    case 'tools':
                        this.$trackEvent('CP+Menu+Tools');
                    break;
                    case 'research-and-education':
                        this.$trackEvent('CP+Menu+Education+and+Resources');
                    break;
                    case 'download-platform':
                        this.$trackEvent('CP+Menu+Download+Platform');
                    break;
                    case 'support':
                        this.$trackEvent('CP+Menu+Support');
                    break;
                   
                }
            }
        },
		mounted() {
			var ww = document.body.clientWidth;
			const _that = this
			if (ww < 991) {
				_that.$parent.classMobileResponsive = false
				$(document).on("click", function(event){
					if(!$(event.target).closest('.subMenuClass').length && !$(event.target).closest('.iconMobile').length){
						_that.$parent.classMobileResponsive = false
					}
				});
			} else if (ww >= 992) { 
			  _that.$parent.classMobileResponsive = true
			};
		}
        
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/left_navbar.vue